<div class="mb-2 opacity-70">
  {{ 'general-configuration.text-align' | translate }}
</div>
<div class="flex gap-4">
  <!-- Text align options -->
  @for (align of alignments; track align) {
    <div
      class="design-option-container"
      [class.selected]="(textAlign$ | async) === align"
      (click)="selectTextAlign(align)"
    >
      <fa-icon [icon]="iconMap[align]"></fa-icon>
    </div>
  }
</div>
